import RequestType from '@Types/common/RequestTypes';

export const requestTypesMap: Record<string, RequestType> = {
  'Leave Request': 'Leave',
  'Passport Request': 'Passport',
  'Re-Joining': 'Resumption',
  'Salary Certificate': 'Salary',
  'Overseas Mission': 'Overseas',
  'IT Requisition': 'ITRequisition',
  'Material Request': 'Material',
  'Attendance Request': 'Attendance',
  'Resignation Request': 'Resignation',
};
